import type { ComponentPropsWithoutRef } from "react";

export const ThreeDotsIcon = ({
  className,
  ...props
}: ComponentPropsWithoutRef<"svg">) => (
  <svg
    width="16"
    height="4"
    viewBox="0 0 16 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M2.16732 1.99984H2.17565M8.00065 1.99984H8.00898M13.834 1.99984H13.8423M3.00065 1.99984C3.00065 2.46007 2.62755 2.83317 2.16732 2.83317C1.70708 2.83317 1.33398 2.46007 1.33398 1.99984C1.33398 1.5396 1.70708 1.1665 2.16732 1.1665C2.62755 1.1665 3.00065 1.5396 3.00065 1.99984ZM8.83398 1.99984C8.83398 2.46007 8.46089 2.83317 8.00065 2.83317C7.54041 2.83317 7.16732 2.46007 7.16732 1.99984C7.16732 1.5396 7.54041 1.1665 8.00065 1.1665C8.46089 1.1665 8.83398 1.5396 8.83398 1.99984ZM14.6673 1.99984C14.6673 2.46007 14.2942 2.83317 13.834 2.83317C13.3737 2.83317 13.0007 2.46007 13.0007 1.99984C13.0007 1.5396 13.3737 1.1665 13.834 1.1665C14.2942 1.1665 14.6673 1.5396 14.6673 1.99984Z"
      stroke="#A8ABB4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
